import type { KanbanConfig, KanbanTemplate } from '../types/kanban';
import { apiCall } from './authApi';
import { handleResponse } from './todoApi';

export const kanbanApi = {
  async getKanbanConfig(listId: number, userEmail: string): Promise<KanbanConfig> {
    const res = await apiCall(`/TodoLists/${listId}/kanban-config?userEmail=${encodeURIComponent(userEmail)}`);
    return handleResponse(res);
  },

  async updateKanbanConfig(listId: number, config: KanbanConfig, userEmail: string): Promise<KanbanConfig> {
    const res = await apiCall(`/TodoLists/${listId}/kanban-config?userEmail=${encodeURIComponent(userEmail)}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(config)
    });
    return handleResponse(res);
  },

  async resetKanbanConfig(listId: number, templateName: string, userEmail: string): Promise<KanbanConfig> {
    const res = await apiCall(`/TodoLists/${listId}/kanban-config/reset?userEmail=${encodeURIComponent(userEmail)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(templateName)
    });
    return handleResponse(res);
  },

  async getKanbanTemplates(userEmail: string): Promise<KanbanTemplate[]> {
    const res = await apiCall(`/TodoLists/kanban-templates?userEmail=${encodeURIComponent(userEmail)}`);
    return handleResponse(res);
  },

  async updateTodoStatus(todoId: number, status: string, userEmail: string) {
    const res = await apiCall(`/TodoItems/${todoId}/status?userEmail=${encodeURIComponent(userEmail)}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status })
    });
    return handleResponse(res);
  }
};
